export function stringToInt(s: string, emptyToNull: boolean = false)
{
    if(s == null || (emptyToNull && s === ''))
        return null;
    
    const n = parseInt(s);
    if(Number.isNaN(n))
        throw `[Invalid Argument Exception] couldn't convert "${s}" to integer number`;
    
    return n;
}

export function stringToIntWithMinus(s: string, emptyToNull: boolean = false)
{
    if(s == null || (emptyToNull && s === ''))
        return null;
     
    if(s == '-'){
      return '-';
    }else{
      let n = parseInt(s);
      if(Number.isNaN(n))
          throw `[Invalid Argument Exception] couldn't convert "${s}" to integer number`;
      return n;
    }
    
}

export const intToString = (n: number, nullToEmpty: boolean = false) => {
    return (n != null) ? JSON.stringify(n) : (nullToEmpty ? '' : null);
}


// WEBPACK FOOTER //
// ./src/converters/converters.ts